export const sliderCursor = (e) => {
  const cursor = document.querySelector('.cursor');
  const circleHalfWidth = cursor.clientWidth / 2;
  const circleHalfHeight = cursor.clientHeight / 2;
  e.addEventListener('mousemove', (e) => {
    const posX = Math.round(e.clientX - circleHalfWidth);
    const posY = Math.round(e.clientY - circleHalfHeight);
    gsap.to(cursor, {
      duration: 0.4,
      ease: 'power2.out',
      scale: 1,
      opacity: 1,
    })
    gsap.to(cursor, {
      duration: 0.8,
      ease: 'power2.out',
      x: posX,
      y: posY,
    });
  })
  e.addEventListener('mouseleave', () => {
    gsap.to(cursor, {
      duration: 0.4,
      ease: 'power2.out',
      scale: 0,
      opacity: 0,
    });
  });
}
